import script from "./RelatorioPdr.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatorioPdr.vue?vue&type=script&setup=true&lang=js"

import "./RelatorioPdr.vue?vue&type=style&index=0&id=5fc85ad8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc85ad8"]])

export default __exports__